import {
    FILES_DOWNLOAD_DOC_POST
} from "../axios";

export const axiosPostAddFiles = async (
    axiosPrivate,
    docType,
    orgId,
    bodyRequest,
    setSelectedFileName,
    setFileSelected,
    setTemplate,
    setMessage,
    updateRequestFiles,
) => {
    try {
        const response = await axiosPrivate.post(
            FILES_DOWNLOAD_DOC_POST + `?doc_type=${docType}&org_id=${orgId}`, bodyRequest, {
                headers: {'Content-Type' : 'multipart/form-data'}
        });
        console.log(response);
        setMessage(" ");
        setSelectedFileName('Select file');
        setFileSelected(false);
        setTemplate({});
        updateRequestFiles();
    } catch (err) {
        setMessage("Error download file, incorrect file format!");
        console.error(err);
        setSelectedFileName('Select file');
        setFileSelected(false);
        setTemplate({});
    }
};
